import React, {
  useMemo,
} from 'react'

import PropTypes from 'prop-types'

import Termly from 'termly-namespace'

import { useConsentConfig } from 'components/ConsentConfigProvider'

import GVLContext from './GVLContext'

import useWebsiteGVLQuery from './hooks/useWebsiteGVLQuery'


export default function GVLProvider({ children, lang, websiteUUID }) {
  const { enable_tcf: enableTCF } = useConsentConfig()

  const enabled = Boolean(Termly.tcf || enableTCF)

  const {
    isLoading,
    websiteGVL,
  } = useWebsiteGVLQuery({
    lang,
    websiteUUID,
  }, {
    enabled,
  })

  // Only expose the GVL when TCF is actually enabled for the current region.
  // The query caches `websiteGVL`, so without this guard a GVL fetched for a
  // TCF region would persist after switching to a non-TCF region (e.g. in the
  // dashboard preview), leaving the TCF banner showing when it should not.
  const value = useMemo(() => ({
    gvl: enabled ? websiteGVL : void 0,
  }), [enabled, websiteGVL])

  // If the GVL fetch takes a litle time, we'll wind up rendering the non-TCF banner
  // and then flip to the TCF banner when the GVL is done loading. So, it's best to
  // just not render anything at all until we're done fetching the data we need.
  if ( isLoading ) {
    console.debug('[Termly] Loading GVL...')
    return null
  }

  return (
    <GVLContext.Provider
      value={ value }
    >
      { children }
    </GVLContext.Provider>
  )
}

GVLProvider.propTypes = {
  websiteUUID: PropTypes.string.isRequired,

  children: PropTypes.node,
  lang: PropTypes.string,
}
